import React, { PropTypes } from 'react';
import parseJson from '../../parseJson';
import './SchoolHomepage.scss';

const DEFAULT_VALUE = {
  homepage: '',
  enable: false,
}

export function schoolhomepage (props) {
  const { 
    options, 
    onChange, 
    required,
  } = props;
  
  let value = parseJson(props.value || DEFAULT_VALUE);

  return (
    <SchoolHomepage
      required={required}
      value={value}
      onChange={(data)=>{ props.onChange(JSON.stringify(data)); }}
      {...options}
    />
  );
}

class SchoolHomepage extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.props.onChange({
      ...this.props.value,
      [name]: value,
    });
  }

  render() {
    const {
      value,
      onChange,
    } = this.props;

    return (
      <div className='schoolhomepage-wrapper form-input outline-form-field'>
        <div className='homepage-url'>
          <input value={value.homepage} onChange={(e)=>this.onChange('homepage', e.target.value)} className='form-control' />
        </div>

        {/* Currently disabled
        <div className='enable-on-yellowpage'>
          <label className='show-homepage'>
            <input type='radio' onChange={()=>this.onChange('enable', true)} checked={value.enable === true} />
            {__('show homepage on Classtop Yellow Page')}
          </label>
          <label className='hide-homepage'>
            <input type='radio' onChange={()=>this.onChange('enable', false)} checked={value.enable !== true} />
            {__('hide')}
          </label>
        </div>
        */}

      </div>
    );
  }
}

export default SchoolHomepage;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SchoolHomepage/index.js